import { render, staticRenderFns } from "./YA_SummarizerContent1.vue?vue&type=template&id=c234a71e&scoped=true"
import script from "./YA_SummarizerContent1.vue?vue&type=script&lang=js"
export * from "./YA_SummarizerContent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c234a71e",
  null
  
)

export default component.exports